module.exports = __webpack_public_path__ + "static/media/source-sans-pro-v11-latin-700.f04441cf.woff2";